var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { mapGetters } from "vuex";
import { format } from "date-fns";
import Autolinker from "autolinker";
export default {
    name: "Message",
    props: ["message"],
    computed: __assign(__assign({}, mapGetters(["localChatPeerId", "getPeerColor"])), { username: function () {
            if (this.isLocal)
                return "You";
            if (this.isMaster)
                return "Host";
            return this.message.username;
        },
        content: function () {
            return this.message.content || "";
        },
        linkedContent: function () {
            return Autolinker.link(this.content, {
                className: "chat-message-url",
                sanitizeHtml: true,
                stripPrefix: false,
            });
        },
        time: function () {
            return format(new Date(this.message.time), "H:mm");
        },
        peerId: function () {
            return this.message.peersIdentifier;
        },
        messageIndex: function () {
            return this.message.index;
        },
        isLocal: function () {
            return this.peerId === this.localChatPeerId;
        },
        isMaster: function () {
            return this.message.master;
        },
        isDeleted: function () {
            return this.message.deleted;
        },
        canBeDeleted: function () {
            return this.isLocal && !this.isDeleted;
        },
        messageBubbleColor: function () {
            if (this.isMaster)
                return "#161616";
            return this.getPeerColor(this.peerId);
        },
        chatBubbleCssClass: function () {
            var bubbleClass = ["chat-bubble"];
            if (this.isMaster)
                bubbleClass.push("chat-bubble-master");
            if (this.isLocal)
                bubbleClass.push("chat-bubble-me");
            if (this.isDeleted)
                bubbleClass.push("chat-bubble-deleted");
            return bubbleClass.join(" ");
        } }),
    methods: {
        deleteMessage: function () {
            this.$socket.sendWithoutSession("deleteChatMessage", {
                index: this.messageIndex,
            });
        },
    },
};



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/Message.vue
// module id = 336
// module chunks = 1